import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo_principal.png';
import { baseURL, sistemaURL } from '../url.js';
import 'swiper/swiper-bundle.css';
import Profile from '../Profile/Profile'
import '../../css/Components/NavBar/NavBar.css'

import Favoritos from '../Favoritos/Favoritos'
import InputSearch from '../InputSearch/InputSearch'

Modal.setAppElement('#root');
export default function Navbar({ banners, info }) {
    const [isOpen, setIsOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [informacion, setInformacion] = useState({
        nombre: 'Cargando',
        direccion: '',
        telefono: '',
        correo: '',
        facebook: '',
        instagram: '',
        whatsapp: '',
    });
    useEffect(() => {
        cargarBanners();
        //cargarInfo(); 
    }, [banners]);

    const cargarBanners = () => { setImages(banners); setLoading(false); };

    const cargarInfo = () => { setInformacion(info) };
    return (
        <header>
            <nav>
                <Anchor to={`/`} className='logo new'>
                    <img src={logo} alt="logo" />
                    {/* <img src="/static/media/logo_principal.png" alt="Logo Principal" /> */}
                    {/* <div className='deColumnNav'>
                        <h2>    {informacion?.nombre}   </h2>
                        <strong>{informacion?.direccion}</strong>
                    </div> */}
                </Anchor>

                <div className='deFLexNavs'>
                    {/* <img src="/static/media/logo_principal.png" alt="Logo Principal" /> */}


                    {/* <Favoritos /> */}

                    <InputSearch />
                    <div className={`nav_toggle  ${isOpen && "open"}`} onClick={() => setIsOpen(!isOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>


                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => setIsOpen(false)}
                    className="modalNav"
                    overlayClassName="overlay uncuarto"

                >
                    <div className="modalNav-content">
                        {loading ? (
                            <div className='loadingBannerFondo'>

                            </div>

                        ) : (

                            <>

                                <div className='fondo'>
                                    <img src={`${sistemaURL}` + images[0]} alt={`imagen`} />

                                </div>
                                <Profile info={info} />

                            </>
                        )}

                    </div>
                </Modal>

            </nav>
        </header>
    );
}
